<template>
  <div>
    <!-- 好友列表 -->
    <el-row v-loading="loading" style="padding-top: 10px; background: #fff">
      <el-table
          @cell-click="setUserInfo"
          :data="orderdata.data"
          stripe
          style="width: 100%"
          :show-header="false"
      >
        <el-table-column label="日期">
          <template slot-scope="scope">
            <div class="userlist">
              <div class="FlexBox FlexBox2">
                <el-avatar :src="HZimg" style="margin-top: 12px"></el-avatar>
                <div>
                  <div>{{ scope.row.payTime }}</div>
                  <div style="line-height: 30px">
                    <!-- <div>&nbsp;&nbsp;</div> -->
                    <div class="flexBox" style="justify-content: space-between">
                      <div
                      ><strong>{{ scope.row.userName }}</strong></div
                      >
                      <div>{{ scope.row.sex }}
                      </div
                      >
                      <div>{{ scope.row.age }}</div>
                    </div>
                  </div>
                  <!-- <div>
                    <span>图文问诊</span><span>复诊</span><span>离线</span>
                  </div> -->
                </div>
              </div>
              <div class="FlexBox">
                <div></div>
                <!-- <div v-if="scope.row.startTime != 2">
                  <el-button
                    type="success"
                    size="mini"
                    v-if="scope.row.startTime === null"
                    @click="StartOrOver(scope.row)"
                    >接诊</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    v-if="scope.row.startTime !== null"
                    @click="StartOrOver(scope.row)"
                    >结束问诊</el-button
                  >
                </div> -->
                <div v-if="scope.row.startTime !== null" style="padding-right:0px">
                  <span class="statusIcon" style="background: #0caf60"></span
                  >已接诊
                </div>
                <div v-if="scope.row.startTime === null" style="padding-right:0px">
                  <span class="statusIcon" style="background: #ffc700"></span
                  >待接诊
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
        @current-change="handleCurrentChange"
        :page-size="6"
        layout="total, prev, pager, next"
        :total="PageCounts"
        class="paginationBox"
        align="center"
    >
    </el-pagination>
    <el-dialog
        :visible.sync="tipsFlag"
        width="30%"
        :show-close="false"
        :close-on-click-modal="false"
        class="tipsMsgBox"
        :modal="false"
    >
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>

<script>
import store from "../../../../store/store";
import {orderList, Treated, overOrder} from "@/api/index";
import HZimg from "../../../../img/患者.png";

export default {
  data() {
    return {
      keyword: "",
      patientsFlag: false,
      PostorderList: {
        status: "",
        cp: "1",
        lz: "6",
      },
      orderdata: {},
      loading: true,
      PageCounts: 1,
      StatusFlag: false,
      showMsgFlag: false,
      numberFlag: 0,
      HZimg: HZimg,
      tipsFlag: false,
      tipsMsg: "",
      startEventFlag: true,
    };
  },
  props: {
    reLoadAsideFlag: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    setUserInfo(row, column, event) {
      if (row.userName == "默认群聊") {
        store.commit("changeChatType", "group");
      } else {
        store.commit("changeChatType", "private");
      }
      store.commit("setUserInfo", {
        name: row.userName,
        idNo: row.idNo,
        orderNumber: row.orderNumber,
        id: row.id,
        startTime: row.startTime,
        hospitalCode: row.hospitalCode
      });
      // 将中药用法用量等参数随recordData一起存入，用于聊天页回显
      if (row.prescrKind) {
        localStorage.setItem('prescrKind', row.prescrKind);
      }
      let sufferer = {};
      sufferer.id = row.id;
      sufferer.orderNumber = row.orderNumber;
      if (this.numberFlag !== 1) {
        this.showMsgFlag = true;
        this.PostStatus(row);
      }
      this.numberFlag = 0;
      store.commit("SET_SURRFERID", sufferer.id);
      if (this.startEventFlag) {
        store.commit("SET_ORDERNUMBER", sufferer.orderNumber);
      }
      store.commit("SET_ORDERDRUGLIST", row.orderDrugList);
      store.commit("SET_RECORDDATA", row);
      let opspInfo = {
        diseCode: row.diseCode || '',
        diseName: row.diseName || '',
        medType: row.medType || ''
      };
      store.commit("SET_OPSPINFO", opspInfo);
    },
    setOrderList() {
      this.PostorderList.status = [2, 7] + "";
    },
    async StartOrOver(data) {
      this.startEventFlag = false;
      let sufferer = {};
      sufferer.id = data.id;
      if (data.startTime === null) {
        await Treated(sufferer).then((query) => {
          if (query.code == 0) {
            store.commit("SET_SURRFERID", sufferer.id);
            store.commit("SET_ORDERNUMBER", data.orderNumber);
            data.startTime = "1";
            this.showMsgFlag = true;
            this.StatusFlag = true;
            // store.commit("SET_COUNT", 0);
            this.startEventFlag = true;
            store.commit("SET_STATUSFLAG", this.StatusFlag);
            store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
          } else {
            this.errorTipsMsg(query.msg);
          }
        });
      } else {
        overOrder(sufferer).then((data2) => {
          if (data2.code == 0) {
            this.orderListLoad();
            localStorage.removeItem(data.orderNumber);
            this.showMsgFlag = false;
            this.StatusFlag = false;
            this.startEventFlag = true;
            store.commit("SET_STATUSFLAG", this.StatusFlag);
            store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
          } else {
            this.errorTipsMsg(data2.msg);
          }
        });
      }
      this.numberFlag = 1;
      // store.commit("SET_STATUSFLAG", this.StatusFlag);
      // store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
    },
    orderListLoad() {
      this.loading = true;
      let postData = {
        cp: this.PostorderList.cp,
        lz: this.PostorderList.lz,
        // status: this.PostorderList.status,
      };
      orderList(postData).then((data) => {
        if (data.code == 0) {
          this.PageCounts = data.data.count - 0;
          this.orderdata = data.data;
          this.orderdata.data.forEach((item) => {
            if (item.payTime.length == 19) {
              item.payTime = item.payTime.substring(0, item.payTime.length - 3);
            }
            item.age = item.userAge + "岁";
            item.sex = item.userSex == 1 ? "男" : "女";
          });
          this.loading = false;
        } else {
          this.errorTipsMsg(data.msg);
          this.loading = false;
        }
      });
    },
    handleCurrentChange(val) {
      this.PostorderList.cp = val.toString();
      this.orderListLoad();
    },
    PostStatus(val) {
      if (val.startTime === null) {
        this.StatusFlag = false;
      } else {
        this.StatusFlag = true;
      }
      store.commit("SET_STATUSFLAG", this.StatusFlag);
      store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
    },
    GetAge(identityCard) {
      var len = (identityCard + "").length;
      if (len == 0) {
        return 0;
      } else {
        if (len != 15 && len != 18) {
          //身份证号码只能为15位或18位其它不合法
          return 0;
        }
      }
      var strBirthday = "";
      if (len == 18) {
        //处理18位的身份证号码从号码中得到生日和性别代码
        strBirthday =
            identityCard.substr(6, 4) +
            "/" +
            identityCard.substr(10, 2) +
            "/" +
            identityCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday =
            "19" +
            identityCard.substr(6, 2) +
            "/" +
            identityCard.substr(8, 2) +
            "/" +
            identityCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (
          nowDateTime.getMonth() < birthDate.getMonth() ||
          (nowDateTime.getMonth() == birthDate.getMonth() &&
              nowDateTime.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return "女";
          }
          return "男";
        }
      }
    },
    errorTipsMsg(str) {
      this.tipsFlag = true;
      this.tipsMsg = str;
      setTimeout(() => {
        this.tipsFlag = false;
      }, 2000);
    },
  },
  watch: {
    reLoadAsideFlag: function (NewValue, OldValue) {
      if (NewValue > OldValue) {
        this.$message({
          message: "您有一条新预约，请尽快处理",
          type: "success",
        });
      }
      this.orderListLoad();
    },
    // deep: true,
  },
  mounted() {
    this.setOrderList();
    this.orderListLoad();
  },
  computed: {
    tableData() {
      return store.state.userList;
    },
    myInfo() {
      return store.state.myInfo;
    },
  },
};
</script>
<style scoped>
.myinfo {
  text-align: left;
  vertical-align: middle;
  margin-top: 10px;
  margin-left: 10px;
}

.myinfo span {
  text-align: left;
  vertical-align: middle;
}

.userlist {
  vertical-align: middle;
  cursor: pointer;
}

.userlist span {
  vertical-align: middle;
  margin-right: 10px;
}

.searchInput {
  width: 94%;
  margin: 2% 3.5%;
}

.FlexBox {
  display: flex;
  justify-content: space-between;
  text-align: left;
}

.FlexBox2 {
  justify-content: space-between;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.userlist .statusIcon {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-radius: 6px;
}
</style>